import { IBodyDisplayUnits } from "features/profile/profileTypes"
import { mmToFeetInches } from "./heightConverter"

export const MIN_BODY_FEET = 4
export const MAX_BODY_FEET = 7
export const MAX_BODY_INCHES = 3

const MAX_METRIC_HEIGHT = 2200
const MIN_METRIC_HEIGHT = 1200

const validateMetricHeight = (mmHeight: number) => {
  if (mmHeight < MIN_METRIC_HEIGHT || mmHeight > MAX_METRIC_HEIGHT) {
    return "Height must be between 120,0 cm and 220,0 cm."
  }

  return ""
}

const validateImperialHeight = (mmHeight: number) => {
  const { feet, inches } = mmToFeetInches(mmHeight)

  const inShorterMinHeight = feet < MIN_BODY_FEET

  const inTallerMaxHeight =
    feet > MAX_BODY_FEET || (feet === MAX_BODY_FEET && inches > MAX_BODY_INCHES)

  if (inShorterMinHeight || inTallerMaxHeight) {
    return `Height must be between 4'0" and 7'3".`
  }

  return ""
}

export const validateBodyHeight = (
  bodyDisplayUnits: IBodyDisplayUnits,
  mmHeight: number,
) => {
  return bodyDisplayUnits === "METRIC"
    ? validateMetricHeight(mmHeight)
    : validateImperialHeight(mmHeight)
}
